import { Component, OnInit, Optional, ViewChild } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { User } from './common/models/user';
import { Observable } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { setStepperStep } from './calculation/calculation.actions';
import { Store } from '@ngrx/store';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ChangeTitleService } from './common/core/services/change-title.service';
import { CalculationStepRoutes, CalculationTypeRoutes } from './calculation/calculation.constants';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../environments/environment';
import { CoreComponent } from './core.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends CoreComponent implements OnInit {
  public loggedInUser: Observable<User | null>;
  currentRoute = '';
  @ViewChild('sidenav') sidenav!: MatSidenav;
  calculationRoutes = CalculationTypeRoutes;
  calculationStepRoutes = CalculationStepRoutes;

  constructor(
    private readonly authService: AuthService,
    @Optional() private readonly gtmService: GoogleTagManagerService,
    private store: Store,
    private changeTitleService: ChangeTitleService,
    public router: Router,
  ) {
    super();
    this.loggedInUser = this.authService.currentUser;
  }

  ngOnInit() {
    if (!!environment.gtm) {
      this.gtmService.addGtmToDom();
    }
    this.changeTitleService.changeTitle();
    const navigationEvents = this.router.events.pipe(filter((event) => event instanceof NavigationEnd));
    navigationEvents.subscribe((event) => {
      if (event instanceof RouterEvent) {
        this.currentRoute = event.url.split('?')[0];
      }
    });
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.querySelector('.mat-sidenav-content').scrollTop = 0;
      this.linkService.removeTag();
    });
  }

  logout() {
    this.authService.logout();
  }

  onMenuClick(event: any) {
    if (event) {
      this.sidenav.open();
    }
  }

  menuClick() {
    this.sidenav.close();
    this.store.dispatch(setStepperStep({ stepperStep: 1 }));
  }
}
